import { createStore } from 'vuex'

export default createStore({
    state: {
        activeName: sessionStorage.getItem('activeName') || '',
        activePath: sessionStorage.getItem('activePath') || '',
        isMobile: false,//是否为手机端
    },
    getters: {

    },
    mutations: {
        updateActiveName(state, val) {
            sessionStorage.setItem('activeName', val);
            state.activeName = val;
        },
        updateActivePath(state, val) {
            sessionStorage.setItem('activePath', val);
            state.activePath = val;
        },
        updateMobile(state, val) {
            state.isMobile = val;
        }
    },
    actions: {
    },

    modules: {
    }
})

